<template>
  <nav class="navigation-wrap">
    <div v-if="data" class="max-h-full overflow-hidden">
      <ul class="flex-inline flex-wrap max-sm:flex-col" v-for="{ page } in data">
        <li class="group">
          <nuxt-link class="block p-3 text-neutral font-bold" :to="`${page?.url}`"> {{ page?.title }}</nuxt-link>
        </li>
      </ul>
    </div>
  </nav>
</template>
<style scoped>
</style>
<script setup lang="ts">
const { fetchNavigation, data } = useNavigation("top_navigation");

await fetchNavigation("top_navigation");
const NuxtLink = resolveComponent('NuxtLink');
</script>
